<template>
	<nav id="globalNavigation" class="navigation" :class="classes">
		<!-- Region Switcher -->
		<RegionSwitcher />

		<div class="global-navigation">
			<svgIcons class="hide"></svgIcons>
			<!-- overlay and click-outside -->
			<transition name="fade">
				<div v-if="openGameList" class="overlay"></div>
				<div v-if="openSideBar" class="overlay"></div>
			</transition>
			<div v-if="openSideBar" class="blank-area" @click="toggleSidebar"></div>
			<div v-if="openGameList" class="blank-area" @click="toggleGameList"></div>
			<!-- overlay and click-outside end-->
			<div class="left-section pull-left">
				<a
					v-if="!isJapan"
					class="nav-logo"
					:href="`${nexonHome}${language ? `/${language}` : ''}`"
					@click="onTopLevel(`Nexon Logo`)"
				>
					<svgIcon icon-holder-class="nexon-logo" icon-id="nexon-logo" />
				</a>
				<span v-else class="nav-logo">
					<svgIcon icon-holder-class="nexon-logo" icon-id="nexon-logo" />
				</span>
				<a v-if="!isJapan" class="nav-games-list nav-web text-uppercase" :class="{ active: openGameList }" @click="toggleGameList">
					{{ $t('navigation.games') }}
					<svgIcon :class="{ active: openGameList }" icon-holder-class="icon-btn-down" icon-id="icon-btn-down" />
				</a>
				<a v-if="showShop" class="nav-shop nav-web text-uppercase" href="" @click="onTopLevel(`navigation.shop`)">
					{{ $t('navigation.shop') }}
				</a>
				<a
					class="nav-support nav-web text-uppercase"
					:href="supportLink[supportLinkRegion]"
					@click="onTopLevel(`navigation.support`)"
				>
					{{ $t('navigation.support') }}
				</a>
				<a
					v-if="isUS"
					class="nav-support nav-web text-uppercase"
					href="https://pressroom.nexon.com/"
					@click="onTopLevel(`navigation.pressroom`)"
				>
					{{ $t('navigation.pressroom') }}
				</a>
			</div>

			<div v-click-outside="closeMyAccount" class="right-section pull-right">
				<div v-if="isMobile === false && !isJapan" class="download-launcher nav-web">
					<button class="btn home" @click="downloadLauncher">
						<svgIcon icon-holder-class="icon-btn-download" icon-id="icon-btn-download" />
						<span class="text-uppercase">{{ $t('navigation.downloadLauncher') }}</span>
					</button>
				</div>
				<div v-if="showAddBalanceOutsideDropdown && !isJapan" class="nav-web nav-add-balance">
					<a
						:href="myAccountList[region][0].url"
						class="btn  text-uppercase"
						:class="[region === 'global' ? 'btn-buy-nx' : 'btn-add-balance', isMobile ? 'mobile' : '']"
						@click="onMyAccountList(`navigation.${myAccountList[region][0].name}`)"
					>
						{{ $t(`navigation.${myAccountList[region][0].name}`) }}
					</a>
				</div>
				<a class="nav-toggle" @click="toggleSidebar">
					<svgIcon icon-holder-class="icon-btn-menu" icon-id="icon-btn-menu" />
				</a>
				<a
					v-if="!isLoggedIn"
					class="nav-account login nav-web text-uppercase"
					:href="login"
					@click="onTopLevel(`navigation.logIn`)"
				>
					{{ $t('navigation.logIn') }}
				</a>
				<a
					v-if="!isLoggedIn"
					class="nav-account create nav-web text-uppercase"
					:href="createAccount"
					@click="onTopLevel(`navigation.createAccount`)"
				>
					{{ $t('navigation.createAccount') }}
				</a>
				<a v-else class="nav-account profile nav-web" @click="toggleAccountDropDown">
					<svgIcon icon-holder-class="icon-profile" icon-id="icon-profile" />
					<span class="nav-profile-name">{{ isOverflowGnb ? String(nexonTag).substring(0, 16) + '...' : nexonTag }}</span>
				</a>
				<transition name="slide">
					<ul
						v-if="openAccountDropDown"
						class="list-unstyled account-dropdown"
						:class="{ mobile: isMobile, 'hide-add-balance': showAddBalanceOutsideDropdown, japan: isJapan }"
					>
						<div v-if="!isJapan" class="wallet-preview">
							<BalanceSection />
						</div>
						<div v-if="!isJapan" class="account-divider"></div>
						<li v-if="!showAddBalanceOutsideDropdown && !isJapan" class="account-list add-balance">
							<a
								:href="myAccountList[region][0].url"
								class="dropdown-account-btn"
								:class="myAccountList[region][0].name"
								@click="onMyAccountList(`navigation.${myAccountList[region][0].name}`)"
								>{{ $t(`navigation.${myAccountList[region][0].name}`) }}</a
							>
						</li>
						<li v-if="!isJapan" class="account-list review-purchase">
							<a
								:href="myAccountList[region][1].url"
								class="dropdown-account-btn"
								:class="myAccountList[region][1].name"
								@click="onMyAccountList(`navigation.${myAccountList[region][1].name}`)"
								>{{ $t(`navigation.${myAccountList[region][1].name}`) }}</a
							>
						</li>
						<div v-if="!isJapan" class="account-divider"></div>
						<li class="account-list account-setting">
							<a
								:href="myAccountList[region][2].url"
								class="dropdown-account-btn"
								:class="myAccountList[region][2].name"
								@click="onMyAccountList(`navigation.${myAccountList[region][2].name}`)"
								>{{ $t(`navigation.${myAccountList[region][2].name}`) }}</a
							>
						</li>
						<div class="account-divider"></div>
						<li class="account-list logout">
							<a
								:href="myAccountList[region][3].url"
								class="dropdown-account-btn"
								:class="myAccountList[region][3].name"
								@click="onTopLevel(`navigation.${myAccountList[region][3].name}`)"
								>{{ $t(`navigation.${myAccountList[region][3].name}`) }}</a
							>
						</li>
					</ul>
				</transition>
			</div>
		</div>

		<!-- game list  -->
		<div class="games-list-section">
			<transition name="slide">
				<div v-if="openGameList" class="games-list">
					<div class="games-list-content">
						<GameFilter :selected-filter="selectedFilter" :games="games" @setFilter="setFilter"></GameFilter>
						<a class="close" @click="toggleGameList">
							<svgIcon icon-holder-class="icon-btn-close" icon-id="icon-btn-close" />
						</a>
						<GameList :selected-game-list="selectedGameList" :selected-filter="selectedFilter"> </GameList>
					</div>
				</div>
			</transition>
		</div>

		<!-- main side bar -->
		<div class="sidebar-section">
			<transition name="slide">
				<div v-if="openSideBar" class="sidebar">
					<div class="mobile-menu">
						<div class="sidebar-top">
							<div class="sidebar-nav-logo-container">
								<svgIcon icon-holder-class="nexon-logo" icon-id="nexon-logo" />
							</div>
							<a class="close" @click="toggleSidebar">
								<svgIcon icon-holder-class="icon-btn-close" icon-id="icon-btn-close" />
							</a>
						</div>
						<div class="sidebar-content">
							<div v-if="!isJapan" class="sidebar-btns">
								<a class="sidebar-btn games" @click="toggleSubSidebar">
									<span class="text-uppercase text-white">{{ $t('navigation.games') }}</span>
									<svgIcon icon-holder-class="icon-btn-right" icon-id="icon-btn-right" />
								</a>
							</div>
							<div v-if="showShop" class="sidebar-btns">
								<a href="" class="sidebar-btn shop" @click="onTopLevel(`navigation.shop`)">
									<span class="text-uppercase text-white">{{ $t('navigation.shop') }}</span>
								</a>
							</div>
							<div class="sidebar-btns">
								<a
									:href="supportLink[supportLinkRegion]"
									class="sidebar-btn support"
									@click="onTopLevel(`navigation.support`)"
								>
									<span class="text-uppercase text-white">{{ $t('navigation.support') }}</span>
								</a>
							</div>
							<div v-if="isUS" class="sidebar-btns">
								<a
									href="https://pressroom.nexon.com/"
									class="sidebar-btn pressroom"
									@click="onTopLevel(`navigation.pressroom`)"
								>
									<span class="text-uppercase text-white">{{ $t('navigation.pressroom') }}</span>
								</a>
							</div>
						</div>
						<div class="divider"></div>
						<div class="sidebar-account-content">
							<div v-if="!isLoggedIn">
								<div class="sidebar-account-btns">
									<div class="sidebar-account-profile login">
										<div class="profile-btn-group login">
											<a :href="login" class="profile-btn login" @click="onTopLevel(`navigation.logIn`)">
												<span>{{ $t('navigation.logIn') }}</span>
											</a>
										</div>
										<div class="profile-btn-group create-account">
											<a
												:href="createAccount"
												class="profile-btn create-account"
												@click="onTopLevel(`navigation.createAccount`)"
											>
												<span>{{ $t('navigation.createAccount') }}</span>
											</a>
										</div>
									</div>
								</div>
							</div>
							<div v-else>
								<div class="sidebar-account-btns">
									<div class="sidebar-account-profile logout">
										<div class="profile-btn-group icon-profile">
											<svgIcon icon-holder-class="icon-profile" icon-id="icon-profile" />
										</div>
										<div class="profile-btn-group logout">
											<a
												v-if="logoutMenu"
												:key="`myAccount-${logoutMenu.name}`"
												:href="logoutMenu.url"
												class="profile-btn logout"
												@click="onTopLevel(`navigation.logout`)"
											>
												<span>{{ $t('navigation.logout') }}</span>
											</a>
										</div>
									</div>
									<div class="sidebar-profile-name">
										<span>{{ nexonTag }}</span>
									</div>
									<div v-if="!isJapan" class="sidebar-wallet-preview">
										<BalanceSection />
									</div>
									<ul class="list-unstyled">
										<li v-if="addBalanceMenu && !showAddBalanceOutsideDropdown && !isJapan">
											<a
												:href="addBalanceMenu.url"
												class="sidebar-add-balance-btn"
												:class="addBalanceMenu.name"
												@click="onMyAccountList(`navigation.${addBalanceMenu.name}`)"
												>{{ $t(`navigation.${addBalanceMenu.name}`) }}</a
											>
										</li>
									</ul>
									<div class="wallet-divider"></div>
									<ul class="list-unstyled">
										<li
											v-for="(myAccount, index) in myAccountList[region].filter(
												(one) => !['logout', 'addBalance', 'buyNx'].includes(one.name) && !one.hidden
											)"
											:key="`myAccount-${index}`"
										>
											<a
												:href="myAccount.url"
												class="sidebar-account-btn"
												:class="myAccount.name"
												@click="onMyAccountList(`navigation.${myAccount.name}`)"
												>{{ $t(`navigation.${myAccount.name}`) }}</a
											>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div v-if="isMobile === false && !isJapan" class="download-launcher">
						<p class="text-uppercase download-launcher-title">{{ $t('navigation.launcher') }}</p>
						<p class="download-launcher-subtitle">{{ $t('navigation.launcherDesc') }}</p>
						<button class="btn home" @click="downloadLauncher">
							<svgIcon icon-holder-class="icon-btn-download" icon-id="icon-btn-download" />
							<span class="text-uppercase">{{ $t('navigation.downloadLauncher') }}</span>
							<span>&nbsp;{{ $t('navigation.downloadLauncherSubTitle') }}</span>
						</button>
					</div>
				</div>
			</transition>

			<!-- sub-side bar -->
			<transition name="slide">
				<div v-if="openSubSideBar" class="sub-sidebar">
					<div class="mobile-menu">
						<div class="sub-sidebar-top">
							<a class="back" @click="toggleSubSidebar">
								<svgIcon icon-holder-class="icon-btn-left" icon-id="icon-btn-left" />
							</a>
							<div class="category-title-container">
								<span>{{ $t('navigation.games') }}</span>
							</div>
							<a class="close" @click="toggleSidebar">
								<svgIcon icon-holder-class="icon-btn-close" icon-id="icon-btn-close" />
							</a>
						</div>
						<div class="sub-sidebar-content">
							<GameFilter :selected-filter="selectedFilter" :games="games" @setFilter="setFilter"></GameFilter>
							<GameList :selected-game-list="selectedGameList" :selected-filter="selectedFilter"> </GameList>
						</div>
					</div>
				</div>
			</transition>
		</div>
		<ReconsentModal :show-modal="showReconsentModal" :confirm-function="confirmReconsentModal"></ReconsentModal>
	</nav>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import svgIcons from '@arena/toolkit/src/components/common/icon-sprite';
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';
import clickOutside from '@arena/toolkit/src/utils/click-outside';
import config from '@/config/config-navigation';
import { DownloadLauncherHost } from '@/config/config-downloadLauncher';
import GameFilter from '@/components/game-filter';
import GameList from '@/components/game-list';
import RegionSwitcher from '@/components/region-switcher';
import BalanceSection from '@/components/balance-section';
import ReconsentModal from '@/components/reconsent-modal';

export default {
	name: 'NavTop',
	components: {
		svgIcons,
		svgIcon,
		GameFilter,
		GameList,
		RegionSwitcher,
		BalanceSection,
		ReconsentModal,
	},
	directives: {
		clickOutside,
	},
	data() {
		return {
			isOverflowGnb: false,
			openGameList: false,
			openAccountDropDown: false,
			openSideBar: false,
			openSubSideBar: false,
			myAccountList: config.myAccount,
			domain: config.domain,
			supportLink: config.supportLinks,
			login: config.domain + '/account/login',
			createAccount: config.domain + '/account/create',
			selectedFilter: 'all',
			windowWidth: null,
			showReconsentModal: false,
		};
	},
	computed: {
		classes() {
			return [
				this.region,
				this.language,
				...(this.showRegionSwitcher ? ['region-switcher'] : []),
				...(this.hideGnb ? ['hideGnb'] : []),
			];
		},
		nexonHome() {
			return `${this.domain}/main`;
		},
		region() {
			return environment.region;
		},
		isJapan() {
			return this.region === 'japan';
		},
		isUS() {
			return this.region === 'global' && this.language === 'en';
		},
		language() {
			return this.$i18n.locale;
		},
		isMobile() {
			return /(iPhone|iPad|Android)/gi.test(navigator.userAgent);
		},
		selectedGameList() {
			return this.games[this.selectedFilter];
		},
		showShop() {
			// Temporary hidden untill further notice
			return false;
		},
		logoutMenu() {
			return this.myAccountList[this.region].find((one) => one.name === 'logout');
		},
		addBalanceMenu() {
			return this.myAccountList[this.region].find((one) =>
				this.region !== 'global' ? one.name === 'addBalance' : one.name === 'buyNx'
			);
		},
		supportLinkRegion() {
			return this.$store.getters.cmsRegionCode;
		},
		showAddBalanceOutsideDropdown() {
			const arr = window.location.pathname.split('/');
			if (arr.length === 3 && arr[1] === 'checkout') {
				// hide the Buy NX button when is checkout verify token page
				return false;
			}
			return !['add-balance', 'purchase'].includes(arr[arr.length - 1]) && this.windowWidth >= 375;
		},
		hideGnb() {
			return window.location.href.indexOf('isToy=true') > -1;
		},
		...mapGetters('regionSwitcher', ['showRegionSwitcher']),
		...mapState(['isLoggedIn', 'nexonTag', 'games', 'isReconsentUser']),
	},
	watch: {
		openAccountDropDown(val) {
			if (val && this.isLoggedIn) this.getBalances();
		},
		openSideBar(val) {
			if (val && this.isLoggedIn) this.getBalances();
		},
		isReconsentUser(val) {
			if (val) this.showReconsentModal = val;
		},
	},
	async created() {
		this.storePartnerKeyCookie();
		const getUrl = window.location;
		// almost arena nexon website is https://*.nexon.com/${locale}/* ,
		// but maplestory website has been another structures. https://test-www.nexon.com/maplestory/*
		const documentLang = document.querySelector('html').lang || 'en';
		const documentArenaShortLang = documentLang.replace(/^(.{2}-)/, '').toLowerCase();
		const langPath = getUrl.pathname.split('/')[2];
		this.setLang(langPath && langPath.length === 2 ? langPath : documentArenaShortLang);
		window.addEventListener('resize', this.handleResize);
		this.windowWidth = window.innerWidth;
	},
	destroyed() {
		window.removeEventListener('resize', this.handleResize);
	},
	mounted() {
		try {
			this.handleResize();
		} catch (e) {
			console.error(e);
		}
	},
	methods: {
		...mapActions(['getBalances']),
		...mapActions('partnerKey', ['storePartnerKeyCookie']),
		handleResize() {
			this.windowWidth = window.innerWidth;

			const leftNavEle = document.querySelector('.left-section');
			const rightNavEle = document.querySelector('.right-section');

			if (leftNavEle && rightNavEle) {
				const gnbEle = document.querySelector('.global-navigation');
				const leftNavWidth = leftNavEle.clientWidth;
				const rightNavWidth = rightNavEle.clientWidth;
				const marginOffset = 110;
				if (leftNavWidth + rightNavWidth + marginOffset >= window.innerWidth) {
					this.isOverflowGnb = true;
					if (gnbEle) {
						document.querySelector('.global-navigation').style.paddingRight = '0px';
					}
				} else {
					this.isOverflowGnb = false;
					if (gnbEle) {
						document.querySelector('.global-navigation').style.paddingRight = '';
					}
				}
			}

			if (window.innerWidth >= 1024 && (this.openSideBar === true || this.openSubSideBar === true)) {
				this.openSideBar = false;
				this.openSubSideBar = false;
			}
			if (window.innerWidth < 1024 && (this.openGameList === true || this.openAccountDropDown === true)) {
				this.openGameList = false;
				this.openAccountDropDown = false;
			}
		},
		closeMyAccount() {
			this.openAccountDropDown = false;
		},
		toggleSidebar() {
			this.openSideBar = !this.openSideBar;
			this.openSubSideBar = false;
			// reset game filter to all game
			this.setFilter('all');
		},
		toggleSubSidebar() {
			this.openSubSideBar = !this.openSubSideBar;
			if (this.openSubSideBar) {
				this.onTopLevel(`navigation.games`);
			}
		},
		toggleGameList() {
			this.openGameList = !this.openGameList;
			if (this.openGameList) {
				this.onTopLevel(`navigation.games`);
			}
		},
		toggleAccountDropDown() {
			this.openAccountDropDown = !this.openAccountDropDown;
			if (this.openAccountDropDown) {
				this.onTopLevel(`Account Dropdown`);
			}
		},
		setFilter(platform) {
			this.selectedFilter = platform;
		},
		onMyAccountList(accountLink) {
			dataLayer.push({
				event: 'GNB Account Link Clicked',
				gnbAccountLinkClicked: this.$t(accountLink, 'en-US'),
			});
		},
		onTopLevel(topLevelLink) {
			dataLayer.push({
				event: 'GNB Top Level Click',
				gnbElement: this.$t(topLevelLink, 'en-US'), //This is what the user clicked on. Nexon Logo, Games, Shop, Support, Account Dropdown, Login, Create Account, Launcher Download
			});
		},
		downloadLauncher() {
			dataLayer.push({ event: 'GNB Top Level Click', gnbElement: 'Launcher Download' });
			const launcherType = this.region === 'global' ? '' : `_${this.region.toUpperCase()}`,
				partnerKey = this.getParameterByName('partnerkey'),
				base = new URL(DownloadLauncherHost[process.env.NODE_ENV]);

			base.searchParams.set('file', `NexonLauncherSetup${launcherType}.exe`);

			try {
				// Firefox private mode doesn't support window.ga.getAll function
				base.searchParams.set('client-id', `${window.ga.getAll()[0].get('clientId')}`);
				// eslint-disable-next-line
			} catch (e) {}
			if (partnerKey) {
				base.searchParams.set('partnerkey', partnerKey);
			}
			window.location = base.href;
		},
		getParameterByName(name, url) {
			if (!url) url = window.location.href;
			name = name.replace(/[[\]]/g, '\\$&');
			const regex = new RegExp(`[?&]${name.toLowerCase()}(=([^&#]*)|&|#|$)`),
				results = regex.exec(url.toLowerCase());
			if (!results) return null;
			if (!results[2]) return '';
			return decodeURIComponent(results[2].replace(/\+/g, ' '));
		},
		setLang(lang) {
			this.$i18n.locale = lang;
		},
		closeReconsentModal() {
			this.showReconsentModal = false;
		},
		confirmReconsentModal() {
			this.closeReconsentModal();
			location.href = this.logoutMenu.url;
		},
	},
};
</script>

<style lang="less" scoped>
@import '~@arena/toolkit/src/less/toolkit/toolkit.less';
.navigation {
	&.hideGnb {
		display: none !important;
	}
	font-family: @font-family-base;
	font-size: 14px;
	&.tw.zh {
		font-family: '微軟正黑體', 'Microsoft JhengHei', Arial, Helvetica, sans-serif;
	}
	h5 {
		font-weight: bold;
	}
	min-width: 375px;
	.global-navigation {
		position: relative;
		z-index: 100;
		background-color: #212224;
		height: 56px;
		min-width: 375px;
		padding: 0 17px 0 24px;
		box-shadow: 0px 2px 7px 0 rgba(0, 0, 0, 0.25);
		&.active {
			display: block;
		}
		.nav-web {
			display: none;
			&.nav-add-balance {
				display: flex;
				&:hover {
					cursor: default;
				}
			}
		}
		.left-section,
		.right-section {
			height: 100%;
			line-height: 1;
			display: flex;
		}
		.left-section {
			.nav-logo {
				margin-top: 21px;
				.nexon-logo {
					width: 93px;
					height: 14px;
					object-fit: contain;
				}
			}
		}
		.right-section {
			.nav-toggle {
				margin-top: 9px;
				cursor: pointer;
				display: flex;
				align-items: center;
				justify-content: center;
				transition: all 0.2s ease;
				width: 37px;
				height: 37px;
				border-radius: 25px;
				opacity: 0.8;
				.icon-btn-menu {
					width: 21px;
					height: 16px;
				}
				&:hover {
					opacity: 1;
					background-color: #2c2d31;
				}
				&:active {
					opacity: 0.5;
				}
			}
			.nav-add-balance {
				align-items: center;
				margin-right: 50px;
				@media (max-width: 1200px) {
					margin-right: 30px;
				}
				@media (max-width: 1023px) {
					margin-right: 17px;
				}
				@media (max-width: 480px) {
					margin-right: 7px;
				}
				.btn-add-balance,
				.btn-buy-nx {
					display: inline-flex;
					align-items: center;
					font-size: 11px;
					color: #fff;
					background-color: #0077ff;
					background-size: 0 100%;
					border: none;
					height: 32px;
					padding: 9px 14px;
					border-radius: 5px;
					transition: background-color 0.5s;
					&:before {
						content: '';
						display: inline-block;
						width: 22px;
						height: 22px;
						background-image: url('~@/images/nx.png');
						background-repeat: no-repeat;
						background-size: contain;
						margin-right: 10px;
						border: 1px solid #fff;
						border-radius: 50%;
					}
					&:hover {
						background-color: #0077ff;
						background: linear-gradient(90deg, rgba(0, 119, 255, 1) 0%, rgba(52, 172, 231, 1) 50%, rgba(0, 119, 255, 1) 100%);
						background-repeat: no-repeat;
						background-size: 200% 100%;
						transition: background-size 1s, background-color 3s;
					}
					&:active {
						opacity: 0.3;
						transition: background-size 0s;
					}
					&.mobile {
						transition: none;
						&:hover {
							opacity: 1;
							background: #4ca1ff;
							background-size: none;
							transition: background-color 0.2s ease;
						}
						&:active {
							opacity: 0.8;
						}
					}
				}
				.btn-add-balance {
					&:before {
						background-image: url('~@/images/coin.png');
					}
				}
				.btn-buy-nx {
					&:before {
						background-image: url('~@/images/nx.png');
					}
				}
			}
			.download-launcher.nav-web {
				margin-left: 0;
				margin-right: 50px;
				@media (max-width: 1200px) {
					margin-right: 30px;
				}
			}
		}
		.right-section {
			.section {
				display: none;
			}
		}
	}

	// overlay animation
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.3s;
	}
	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}
	// overlay
	.overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.5);
		z-index: 9999;
	}
	// blank area
	.blank-area {
		position: fixed;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 9999;
	}

	// sidebar animation
	.sidebar-section {
		// sidebar animation
		.slide-enter-active,
		.slide-leave-active {
			transition: 0.3s ease;
			overflow: hidden;
		}
		.slide-enter,
		.slide-leave-to {
			transform: translate(400px);
		}

		// sidebar
		.sidebar,
		.sub-sidebar {
			position: fixed;
			top: 0;
			right: 0;
			bottom: 0;
			width: 375px;
			min-width: 320px;
			height: 100%;
			-webkit-box-sizing: border-box;
			box-sizing: border-box;
			overflow: hidden;
			background-color: #212224;
		}

		// main sidebar
		.sidebar {
			z-index: 9999;
			box-shadow: -10px 0px 32px 0 rgba(0, 0, 0, 0.7);
			.mobile-menu {
				.sidebar-top {
					width: 100%;
					height: 60px;
					box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.7);
					.sidebar-nav-logo-container {
						height: 100%;
						display: flex;
						justify-content: center;
						align-items: center;
						.nexon-logo {
							width: 93px;
							height: 14px;
						}
					}
					.close {
						position: absolute;
						top: 11px;
						right: 20px;
						opacity: 0.8;
						display: flex;
						align-items: center;
						justify-content: center;
						transition: all 0.2s ease;
						width: 37px;
						height: 37px;
						border-radius: 25px;
						.icon-btn-close {
							width: 20px;
							height: 20px;
						}
						&:hover {
							opacity: 1;
							background-color: #2c2d31;
						}
						&:active {
							opacity: 0.5;
						}
					}
				}
				.sidebar-content {
					margin: 20px 0px;
					.sidebar-btns {
						border-left: 3px solid transparent;
						width: 100%;
						height: 54px;
						transition: 0.2s ease;
						&:hover {
							border-left: 3px solid #0077ff;
							background-color: #303134;
						}
						&:active {
							opacity: 0.5;
						}
						.sidebar-btn {
							display: flex;
							align-items: center;
							padding: 10px 30px;
						}
						.games,
						.shop,
						.support,
						.pressroom {
							cursor: pointer;
							width: 100%;
							height: 100%;
						}
						.games {
							.icon-btn-right {
								margin-left: auto;
								width: 12px;
								height: 12px;
							}
						}
					}
				}
				.divider {
					margin: 0 20px;
					border-bottom: 1px solid rgba(255, 255, 255, 0.1);
				}
				.sidebar-account-content {
					margin-top: 20px;
					.sidebar-account-btns {
						.sidebar-account-profile {
							display: flex;
							align-items: center;
							padding: 0 20px 0 33px;
							margin-bottom: 12px;
							&.login {
								justify-content: flex-end;
							}
							&.logout {
								justify-content: space-between;
							}
							.profile-btn-group {
								&.login {
									margin-right: 10px;
								}
								.icon-profile {
									width: 28px;
									height: 28px;
								}
								.profile-btn {
									display: flex;
									align-items: center;
									justify-content: center;
									height: 26px;
									border-radius: 5px;
									border: solid 1px #959696;
									cursor: pointer;
									font-size: 11px;
									color: #959696;
									transition: 0.2s ease;
									&:hover {
										color: rgba(255, 255, 255, 1);
										border: solid 1px rgba(255, 255, 255, 1);
									}
									&:active {
										opacity: 0.5;
									}
									&.logout,
									&.login,
									&.create-account {
										padding: 0px 10px;
									}
								}
							}
						}
						.sidebar-profile-name {
							padding: 0 33px;
							margin-bottom: 32px;
							color: rgba(255, 255, 255, 1);
						}
						.sidebar-wallet-preview {
							padding: 0 20px 0 33px;
							width: 100%;
							margin-bottom: 20px;
							.balance-section:not(:last-child) {
								margin-bottom: 9px;
							}
							.balance-section ::v-deep {
								justify-content: flex-start;
								.balance-category {
									color: rgba(255, 255, 255, 1);
									margin-right: 0px;
								}
								.balance-amount {
									white-space: nowrap;
								}
								.spinner-circle {
									&--balance {
										margin-left: 0px;
									}
								}
							}
						}
						.sidebar-add-balance-btn {
							display: inline-block;
							text-align: center;
							width: calc(100% - 66px);
							padding: 10px 30px;
							margin: 0 33px 20px 33px;
							border-radius: 5px;
							background-size: 0 100%;
							background-color: #0077ff;
							color: rgba(255, 255, 255, 1);
							font-weight: bold;
							transition: background-color 0.2s ease;
							&:hover {
								background-color: #4ca1ff;
							}
						}
						.wallet-divider {
							margin: 0 20px;
							width: calc(100% - 40px);
							margin-bottom: 20px;
							border-bottom: 1px solid rgba(255, 255, 255, 0.1);
						}
						.sidebar-account-btn {
							display: inline-block;
							width: 100%;
							padding: 0 33px;
							font-size: 13px;
							color: #959696;
							line-height: 2.15;
							letter-spacing: -0.26px;
							transition: 0.2s ease;
							&:hover {
								color: rgba(255, 255, 255, 1);
							}
							&:active {
								opacity: 0.5;
							}
						}
					}
				}
			}
			.download-launcher {
				position: absolute;
				bottom: 0;
				width: 100%;
				height: 154px;
				background-color: #171719;
				padding: 26px 21px 20px 21px;
				font-family: Arial;
				font-size: 14px;
				.download-launcher-title {
					font-weight: bold;
					color: #a9a9ab;
					line-height: 1;
					margin-bottom: 9px;
				}
				.download-launcher-subtitle {
					color: #5b5b5c;
					line-height: 1;
					margin-bottom: 17px;
				}
				.btn.home {
					width: 332px;
					height: 45px;
				}
			}
		}

		// sub sidebar
		.sub-sidebar {
			z-index: 10000;
			overflow: hidden;
			height: 100%;
			.mobile-menu {
				height: 100%;
				.sub-sidebar-top {
					width: 100%;
					height: 60px;
					box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.7);
					.back {
						position: absolute;
						top: 12px;
						left: 20px;
						opacity: 0.8;
						display: flex;
						align-items: center;
						justify-content: center;
						transition: all 0.2s ease;
						width: 37px;
						height: 37px;
						border-radius: 25px;
						.icon-btn-left {
							width: 25px;
							height: 25px;
							margin-right: 4px;
						}
						&:hover {
							opacity: 1;
							cursor: pointer;
							background-color: #2c2d31;
						}
						&:active {
							opacity: 0.5;
						}
					}
					.category-title-container {
						height: 100%;
						display: flex;
						justify-content: center;
						align-items: center;
						color: white;
					}
					.close {
						position: absolute;
						top: 11px;
						right: 20px;
						opacity: 0.8;
						display: flex;
						align-items: center;
						justify-content: center;
						transition: all 0.2s ease;
						width: 37px;
						height: 37px;
						border-radius: 25px;
						.icon-btn-close {
							width: 20px;
							height: 20px;
						}
						&:hover {
							opacity: 1;
							background-color: #2c2d31;
						}
						&:active {
							opacity: 0.5;
						}
					}
				}
				.sub-sidebar-content {
					height: calc(100% - 60px);
				}
			}
		}
	}

	// launcher download section
	button {
		span {
			display: inline-block;
			margin-top: 8px;
		}
		.icon-btn-download {
			width: 17px;
			height: 23px;
			margin-right: 10px;
			margin-bottom: 2px;
			vertical-align: middle;
		}
		&.btn.home {
			color: #fff;
			background-color: #0077ff;
			background-size: 0 100%;
			border: none;
			border-radius: 5px;
			padding: 10px 30px;
			transition: background-color 0.5s;
		}
		&.btn.home:hover {
			background-color: #0077ff;
			background: linear-gradient(90deg, rgba(0, 119, 255, 1) 0%, rgba(52, 172, 231, 1) 50%, rgba(0, 119, 255, 1) 100%);
			background-repeat: no-repeat;
			background-size: 200% 100%;
			transition: background-size 1s, background-color 3s;
		}
		&.btn.home:active {
			opacity: 0.3;
			transition: background-size 0s;
		}
	}
}
@media (min-width: 1024px) {
	.navigation {
		// overlay
		.overlay {
			top: 56px; // offset navigation bar
		}
		.global-navigation {
			padding: 0 24px;
			.nav-web {
				display: inline-block;
				font-size: 12px;
				color: rgba(255, 255, 255, 0.7);
				cursor: pointer;
				transition: all 0.2s ease;
				&:hover {
					color: rgba(255, 255, 255, 1);
					&.nav-games-list,
					&.nav-shop,
					&.nav-support {
						border-bottom: 3px solid #0077ff;
					}
					&.nav-games-list .icon-btn-down {
						opacity: 1;
					}
				}
				&:active {
					opacity: 0.5;
				}
			}
			.nav-games-list,
			.nav-shop,
			.nav-support {
				display: flex;
				align-items: center;
				height: 56px;
				padding: 3px 10px 0 10px;
				border-bottom: 3px solid transparent;
			}
			.left-section {
				height: 100%;
				.nav-games-list {
					margin-left: 40px;
					&.active {
						color: rgba(255, 255, 255, 1);
						border-bottom: 3px solid #0077ff;
					}
					.icon-btn-down {
						width: 11px;
						height: 5px;
						margin-left: 10px;
						margin-top: -1px;
						opacity: 0.7;
						transition: opacity 0.2s ease;
						&.active {
							opacity: 1;
							transform: rotate(180deg);
						}
					}
				}
				.nav-shop,
				.nav-support {
					margin-left: 20px;
				}
			}
			.right-section {
				.nav-divider {
					margin-top: 19px;
					height: 16px;
				}
				.nav-divider:before {
					padding: 0 26px 0 20px;
					color: rgba(255, 255, 255, 0.4);
					content: '|\A0';
				}
				.nav-account {
					height: 11px;
					margin-top: 23px;
					font-size: 11px;
					color: rgba(255, 255, 255, 0.4);
					&:hover {
						color: rgba(255, 255, 255, 1);
					}
					&:active {
						opacity: 0.4;
					}
					&.create {
						margin-left: 30px;
					}
					&.profile {
						display: flex;
						align-items: center;
						.icon-profile {
							margin-top: -2px;
							width: 20px;
							height: 20px;
						}
						.nav-profile-name {
							margin-left: 8px;
						}
					}
				}
				// account profile animation
				.slide-enter-active,
				.slide-leave-active {
					transition: 0.2s ease-out;
				}
				.slide-enter-to,
				.slide-leave {
					max-height: 288px;
					overflow: hidden;
				}
				.slide-enter,
				.slide-leave-to {
					overflow: hidden;
					max-height: 0px;
				}
				.account-dropdown.mobile {
					right: 0px;
				}
				.account-dropdown.mobile:before {
					left: 146px;
				}
				.account-dropdown:before {
					position: absolute;
					top: -8px;
					left: 105px;
					display: inline-block;
					border-right: 10px solid transparent;
					border-bottom: 10px solid #2e2f33;
					border-left: 10px solid transparent;
					content: '';
				}
				.account-dropdown {
					&.japan {
						padding-top: 15px;
					}
					position: absolute;
					top: 56px;
					right: 5px;
					width: 230px;
					height: 264px;
					border-radius: 5px;
					box-shadow: 0 0 29px 0 rgba(0, 0, 0, 0.28);
					background-color: #2e2f33;
					.wallet-preview {
						padding: 26px 24px 8px 24px;
						.balance-section:not(:last-child) {
							margin-bottom: 9px;
						}
					}
					.account-divider {
						margin: 10px 24px;
						border-bottom: 1px solid rgba(255, 255, 255, 0.1);
					}
					.account-list {
						width: 230px;
						height: 34px;
						.dropdown-account-btn {
							display: flex;
							align-items: center;
							padding: 0px 24px;
							width: 100%;
							height: 100%;
							color: rgba(255, 255, 255, 0.8);
							transition: all 0.2s ease;
							&:hover {
								background-color: #434448;
								color: rgba(255, 255, 255, 1);
							}
							&:active {
								opacity: 0.5;
							}
						}
					}
					&.hide-add-balance {
						height: 230px;
					}
				}
				.download-launcher {
					display: flex;
					align-items: center;
					margin-left: 24px;
				}
				.nav-toggle {
					display: none;
				}
			}
		}

		.games-list-section {
			// games list animation
			.slide-enter-active,
			.slide-leave-active {
				transition: 0.3s ease;
				overflow: hidden;
			}
			.slide-enter-to,
			.slide-leave {
				max-height: 100%;
				overflow: hidden;
			}
			.slide-enter,
			.slide-leave-to {
				overflow: hidden;
				max-height: 0;
			}
			.games-list {
				position: fixed;
				top: 56px;
				right: 0;
				bottom: 0;
				width: 100%;
				min-width: 320px;
				-webkit-box-sizing: border-box;
				box-sizing: border-box;
				overflow: hidden;
				z-index: 9999;
				background: linear-gradient(rgba(25, 26, 28, 1) 70%, rgba(25, 26, 28, 0.8) 100%);
				.games-list-content {
					.close {
						position: absolute;
						top: 15px;
						right: 30px;
						opacity: 0.8;
						display: flex;
						align-items: center;
						justify-content: center;
						transition: all 0.2s ease;
						width: 37px;
						height: 37px;
						border-radius: 25px;
						.icon-btn-close {
							width: 20px;
							height: 20px;
						}
						&:hover {
							opacity: 1;
							background-color: #2c2d31;
						}
						&:active {
							opacity: 0.5;
						}
					}
				}
			}
		}

		// launcher download section
		button {
			span {
				margin-top: 0px;
			}
			.icon-btn-download {
				width: 11px;
				height: 15px;
				margin-right: 9px;
			}
			&.btn.home {
				min-width: 180px;
				height: 32px;
				padding: 9px 14px;
				font-size: 11px;
			}
		}
	}
}

@media (min-width: 1024px) and (max-width: 1100px) {
	.navigation {
		&.es {
			.left-section {
				.nav-games-list {
					margin-left: 20px;
				}
				.nav-support {
					margin-left: 0px;
				}
			}

			.right-section {
				.download-launcher.nav-web {
					margin-right: 20px;
				}
				.nav-add-balance {
					margin-right: 25px;
					.btn-add-balance,
					.btn-buy-nx {
						padding-left: 10px;
						padding-right: 10px;
					}
				}
				.nav-account.create {
					margin-left: 25px;
				}
			}
		}

		button {
			&.btn.home {
				padding-left: 10px;
				padding-right: 10px;
			}
		}
	}
}
</style>
